import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { IMetaAd } from '../../extViewmodels/sdk/models/Ads';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'getMetaAds';

export const useGetMetaAds = ({
	impersonationContext,
	adAccountId,
	enabled = true,
}: {
	impersonationContext?: Api.IImpersonationContext;
	adAccountId: string;
	enabled?: boolean;
}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<IMetaAd[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `ads/providers/meta/ads?adAccountId=${encodeURIComponent(adAccountId)}`,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, adAccountId, impersonationContext],
		enabled: enabled && !!adAccountId,
		refetchOnWindowFocus: false,
	});
};
